import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../../components/Form'
import FormItem from '../../../components/Form/FormItem'
import InputText from '../../../components/Inputs/InputText'
import Select from '../../../components/Inputs/Select'
import axios from 'axios'
import Datepicker from '../../../components/Inputs/Datepicker'
import InputNumber from '../../../components/Inputs/InputNumber'
import { IoMdAdd } from 'react-icons/io'
import Tooltip from '../../../components/Display/Tooltip'
import {
  dateToDB,
  formatPipe,
  getDenomination,
  getYearMonthAndDay,
  transformDate,
} from '../../../utils/utils'
import Table from '../../../components/Display/Table'
import { ColumnsTable } from 'safe'
import { ColumnItemWrapper } from '../../../components/General/ColumnItemWrapper'
import Button from '../../../components/General/Button'
import { DateTime } from 'luxon'
import useSnackBars from '../../../hooks/SnackbarConsumerHook'
import Modal from '../../../components/Display/Modal'
import AddPaymentForm from './AddPaymentForm'
import { toFixed } from 'accounting'

const server = process.env.REACT_APP_SERVER_URL

const AddPayments: React.FC<IAddPayments> = ({
  purchase,
  onClose,
  url = '/purchase/payment',
  onAddPayment,
}) => {
  const form = useForm()

  const paymentType = [
    { text: 'De contado', value: 1 },
    { text: 'Crédito', value: 2 },
  ]

  const [accounts, setAccounts] = useState<any | null>(null)

  const [selectedAccount, setSelectedAccount] = useState<any | null>(null)

  const [localPayments, setLocalPayments] = useState<any[]>([])

  const [localPaymentsToTable, setlocalPaymentsToTable] = useState<any[]>([])

  const { addAlert } = useSnackBars()

  const [showModal, setShowModal] = useState<boolean>(false)

  const [showAddPayment, setShowAddPayment] = useState<boolean>(false)

  const paymentsColumns: ColumnsTable[] = [
    {
      title: 'Cuenta',
      dataIndex: 'account.code',
      key: 'account.code',
    },
    {
      title: 'Monto',
      dataIndex: 'amount',
      key: 'amount',
      render: (id: number, record: any) => {
        return (
          <ColumnItemWrapper>{`${getDenomination(record?.currency?.id)} ${
            record?.amount
              ? formatPipe(record?.amount)
              : formatPipe((+record?.amount * record?.rate).toFixed(2))
          }`}</ColumnItemWrapper>
        )
      },
    },
    {
      title: 'Fecha',
      dataIndex: 'date',
      key: 'date',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {transformDate(record?.date)}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Referencia',
      dataIndex: 'reference',
      key: 'reference',
    },
  ]

  const getAccounts = async (): Promise<void> => {
    let response = await axios.get(`${server}/finances/account`)
    setAccounts(response.data.accounts)
    let { accounts } = response.data
    setSelectedAccount({
      text: accounts[0]?.description,
      value: accounts[0]?.id,
    })
  }

  useEffect(() => {
    getAccounts()
  }, [])

  const onSubmitPayments = async (): Promise<void> => {
    console.log('local pyaments', localPayments)

    let payments = localPayments.reduce((a, b) => {
      return +a + +b?.amount * +b?.rate
    }, 0)

    console.log('pauments..', payments)

    if (payments <= +purchase?.cost) {
      addAlert({
        message: 'Agregando pago...',
        status: 'loading',
      })
      try {
        await axios.post(`${server}${url}`, {
          id: purchase?.id,
          payments: localPayments,
        })
        addAlert({
          message: 'Pago agregado satisfactoriamente...',
          status: 'success',
        })
        onClose()
      } catch (err) {
        addAlert({
          message: 'Error al agregar pago...',
          status: 'error',
        })
      }
    } else {
      setShowModal(true)
    }
  }

  const obSubmitForm = async (values): Promise<void> => {
    let accountSelected = accounts.find((v) => v.id === selectedAccount.value)

    const [year, month, day] = getYearMonthAndDay(values.date)

    values.amount = formatPipe(values?.amount, true)

    /** Data para mostrar en la tabla */
    let localToTable = {
      account: {
        code: accountSelected?.description,
      },
      amount: values.amount,
      date: new Date(year, month, day).toISOString(),
      reference: values.reference,
    }

    /** Data para hacer peticion. */
    values.date = dateToDB(values.date)
    values.account = {
      id: values.account,
    }
    values.currency = {
      id: accountSelected?.idCurrency,
    }
    delete values.paymentType
    values.rate = 1
    if (accountSelected?.idCurrency !== '2') {
      let response = await axios.get(
        `${server}/finances/rate?date=${values.date}&currency=${accountSelected?.idCurrency}`
      )
      values.rate = response.data.rate.rate
    }
    localToTable = {
      ...localToTable,
      amount: (+values.amount * values.rate).toFixed(2),
    }
    console.log('promesa termina..', values)

    setLocalPayments((prevState) => [...prevState, values])

    const today = DateTime.local().setLocale('es')

    form.setValue('amount', '')
    form.setValue('reference', '')
    // form.setValue('account', '1')
    // form.setValue('date', `${today.day}/${today.month}/${today.year}`)
    setSelectedAccount({
      text: accounts[0]?.description,
      value: accounts[0]?.id,
    })
    setlocalPaymentsToTable((prevState) => [...prevState, localToTable])
  }

  const returnBody = (surplusAction: 'RECEIVABLE' | 'ADVANCE') => {
    let payments = purchase?.payments?.reduce((a, b) => {
      if (b?.newDate) {
        let newObj = {
          account: {
            id: b?.account?.id,
          },
          amount: b?.amount,
          currency: b?.currency,
          date: b?.newDate,
          rate: b?.rate,
          reference: b?.reference,
        }
        return [...a, newObj]
      }

      return a
    }, [])

    return {
      id: purchase?.id,
      payments,
      surplusAction,
    }
  }

  return (
    <div
      // className="grid grid-cols-12 auto-rows-fr gap-4"
      style={{ height: '100%' }}
    >
      {/* <div className="col-span-6" style={{ height: '100%', overflow: 'auto' }}>
        <Form form={form} classes="gap-x-3" onSubmit={() => null}>
          <h2
            className="col-span-12 text-xs font-medium mb-1 flex items-center"
            style={{ color: '#006AEA' }}
          >
            Añadir Pago
          </h2>

          <FormItem
            name="account"
            classes="xl:col-span-9 xl:mb-4 xl:mt-0 lg:col-span-12 mt-5 lg:row-start-2"
            rules={{ required: 'Es necesario una descripcion' }}
          >
            <Select
              label="Cuenta"
              value={selectedAccount}
              options={accounts?.map((v) => ({
                text: v?.description,
                value: v?.id,
              }))}
              onChange={(values) => {
                setSelectedAccount(values)
              }}
            />
          </FormItem>

          <FormItem
            name="date"
            classes="xl:col-span-4 xl:row-start-3 xl:mb-4 col-span-12 xl:mt-1 lg:row-start-2 lg:col-span-4 lg:mt-6"
          >
            <Datepicker label="Fecha" />
          </FormItem>

          <FormItem
            name="amount"
            classes="xl:col-span-5 row-start-3 xl:mb-4 col-span-12 mt-1"
          >
            <InputNumber label="Monto" addDecimals={true} />
          </FormItem>

          <FormItem
            name="reference"
            classes="xl:col-span-5 row-start-3 xl:mb-4 mt-1 lg:col-span-12"
          >
            <label className="font-medium text-primary-900 text-xs dark:text-white">
              Referencia
            </label>
            <input
              ref={form.register}
              className="cursor-text transition w-full dark:bg-gray-600 dark:border-gray-600 dark:text-white h-inputDefault"
              type="text"
            />
          </FormItem>
          
          <div
            onClick={() => {
              obSubmitForm(form.getValues())
            }}
            className="col-span-12 row-start-4 flex flex-row justify-end my-3"
          >
            <IoMdAdd className="text-primary" />
            <u className="text-primary text-xs cursor-pointer">Añadir Pago</u>
          </div>
        </Form>

        <div className="flex ">
          <Button
            type="outline"
            classes="w-1/2 mr-4"
            onClick={() => onClose()}
            htmlType="button"
          >
            Cancelar
          </Button>

          <Button
            type="primary"
            classes="w-1/2 mr-4"
            onClick={() => onSubmitPayments()}
          >
            Guardar
          </Button>
        </div>
      </div> */}

      <div className="flex justify-between mb-3">
        <div className="flex">
          {/* <h1 className='text-xs mr-2'>Monto Total: </h1>
          
          <h1 className='text-xs'>{`${getDenomination(purchase?.currency?.id)}. ${formatPipe(purchase?.cost)}` }</h1> */}
          
          

          <h2 className="col-span-12 mt-1 text-primary-900 font-bold dark:text-white">
            Añadir Pagos
          </h2>
        </div>

        <div className='flex flex-row'>
          <IoMdAdd  className='text-primary mt-1' />
        <h2
          className="col-span-12 text-xs font-medium mb-1 flex items-center cursor-pointer"
          style={{ color: '#006AEA' }}
          onClick={() => {
            // setShowAddPayment(true)
            onAddPayment()
          }}
        >
          Añadir Pago
        </h2>
        </div>

      </div>

      <div style={{ maxHeight: 400, overflow: 'auto' }}>
        <Table
          columns={paymentsColumns}
          data={purchase?.payments.filter((v) => v.new)}
          showPagination={false}
        />

        <div className="flex col-span-12 mt-5 justify-center">
          <Button
            type="outline"
            classes="w-1/2 mr-4"
            onClick={() => {
              onClose()
            }}
            htmlType="button"
          >
            Cancelar
          </Button>

          <Button
            type="primary"
            classes="w-1/2 mr-4"
            onClick={async () => {
              // let payments = purchase?.payments?.filter(payment => payment?.newDate)
              let payments = purchase?.payments?.reduce((a, b) => {
                if (b?.newDate) {
                  let newObj = {
                    account: {
                      id: b?.account?.id,
                    },
                    amount: b?.amount,
                    currency: b?.currency,
                    date: b?.newDate,
                    rate: b?.rate,
                    reference: b?.reference,
                  }
                  return [...a, newObj]
                }

                return a
              }, [])

              let sumPayments = purchase?.payments?.reduce((a, b) => {
                if (b?.newDate) {
                  return (
                    +toFixed(+toFixed(b?.amount, 2) * +toFixed(b?.rate, 2), 2) +
                    a
                  )
                }
                return a
              }, 0)

              if (sumPayments <= +purchase?.cost) {
                addAlert({
                  message: 'Agregando pago...',
                  status: 'loading',
                })
                try {
                  await axios.post(`${server}${url}`, {
                    id: purchase?.id,
                    payments,
                  })
                  addAlert({
                    message: 'Pago agregado satisfactoriamente...',
                    status: 'success',
                  })
                  // setShowAddPayment(false)
                  onClose()
                } catch (err) {
                  addAlert({
                    message: 'Error al agregar pago...',
                    status: 'error',
                  })
                }
              } else {
                setShowModal(true)
              }
            }}
          >
            Guardar cambios
          </Button>
        </div>
      </div>

      <Modal
        display={showModal}
        onClose={() => setShowModal(false)}
        backGroundStyle={{ position: 'fixed' }}
      >
        <h2 className="text-base text-primary">
          {`Tu pago supera en Bs.${formatPipe(
            +toFixed(
              purchase?.payments?.reduce((a, b) => {
                if (b?.newDate) {
                  return +toFixed(+a + +b?.amount * +b?.rate, 2)
                }
                return a
              }, 0) - +toFixed(+purchase?.cost, 2),
              2
            ) + ''
          )} el costo de la ${url.includes('sale') ? 'venta' : 'compra'} 
          ¿Cómo deseas registrar el excedente del pago?"`}
        </h2>
        <div className="h-px dark:bg-primaryGray-600 bg-primaryGray-700 col-span-12 mt-5"></div>

        <div className="flex flex-row justify-around mt-5">
          <label
            className="cursor-pointer"
            style={{ flexBasis: '40%' }}
            onClick={async () => {
              let body = returnBody('RECEIVABLE')
              try {
                addAlert({
                  message: 'Agregando Pago...',
                  status: 'loading',
                })
                await axios.post(`${server}${url}`, body)
                addAlert({
                  message: 'Pago agregado con éxito',
                  status: 'success',
                })
                setShowModal(false)
                onClose()
              } catch (err) {
                addAlert({
                  message: 'Error al agregar pago',
                  status: 'error',
                })
              }
            }}
          >
            {`Registrar como deuda por cobrar al ${
              url.includes('/sale') ? 'cliente' : 'proveedor'
            }`}
          </label>
          <label
            className="cursor-pointer"
            style={{ flexBasis: '40%' }}
            onClick={async () => {
              let body = returnBody('ADVANCE')
              try {
                addAlert({
                  message: 'Agregando pago...',
                  status: 'loading',
                })
                await axios.post(`${server}${url}`, body)
                addAlert({
                  message: 'Pago agregado con éxito',
                  status: 'success',
                })
                setShowModal(false)
                onClose()
              } catch (err) {
                addAlert({
                  message: 'Error al agregar pago',
                  status: 'error',
                })
              }
            }}
          >
            {`Registrar como anticipo al ${
              url.includes('/sale') ? 'cliente' : 'proveedor'
            }`}
          </label>
        </div>
      </Modal>
    </div>
  )
}

interface IAddPayments {
  purchase: any
  onClose: () => void
  url?: string
  onAddPayment: () => void
}

export default AddPayments
